type RouteValue = string | undefined | null | boolean

export function setQueryParams(routeState: Record<string, RouteValue>) {
  const url = new URL(window.location.href)

  for (const [key, value] of Object.entries(routeState)) {
    if (value === undefined || value === null || value === '') {
      url.searchParams.delete(key)
      continue
    }

    url.searchParams.set(key, String(value))
  }

  const query = url.searchParams.toString()
  const search = query ? `?${query}` : ''

  const newUrl = `${url.origin}${url.pathname}${search}${url.hash}`
  window.history.pushState({}, '', newUrl)
}

export function getQueryParams() {
  const url = new URL(window.location.href)
  return Object.fromEntries(url.searchParams.entries())
}
